import Session from 'supertokens-web-js/recipe/session';
import EmailPassword from 'supertokens-web-js/recipe/emailpassword';
import Emailverification from 'supertokens-web-js/recipe/emailverification';
import * as Passwordless from 'supertokens-web-js/recipe/passwordless';

const SuperTokensConfig = {
  appInfo: {
    apiDomain: `${process.env.VUE_APP_SUPERTOKENS_URL}`,
    apiBasePath: '/auth',
    appName: 'Extranet',
  },
  recipeList: [
    EmailPassword.init({
      getRedirectionURL: async (context) => {
        if (context.action === 'RESET_PASSWORD') {
          return '/login';
        }
        return '';
      },
    }),
    Emailverification.init(),
    Passwordless.init(),
    Session.init({
      // tokenTransferMethod: "header",
      override: {
        functions: (oI) => ({
          ...oI,
          shouldDoInterceptionBasedOnUrl: (url, apiDomain, sessionTokenBackendDomain) => {
            try {
              const urlObj = new URL(url);
              if (urlObj.hostname === 'typesense.roomdb.io') return false;
            } catch (ignored) { }
            return true;
          },
        }),
      },
    }),
  ],
};

export default SuperTokensConfig;
